// extracted by mini-css-extract-plugin
export default {"products_cards":"App_products_cards__gpzTx"};